import * as React from 'react';

const URL_REGEX = /(https?:\/\/\S+|www\.\S+)/gi;

export const renderTextWithLinks = (text: string): React.ReactNode => {
	if (!text) {
		return text;
	}

	return text.split(URL_REGEX).map((part, i) => {
		if (!part) {
			return part;
		}

		const isHttp = /^https?:\/\//i.test(part);
		const isWww = /^www\./i.test(part);

		if (isHttp || isWww) {
			const href = isHttp ? part : `https://${part}`;
			return (
				<a
					key={i}
					href={href}
					target='_blank'
					rel='noopener noreferrer'
					onClick={(e) => e.stopPropagation()}
				>
					{part}
				</a>
			);
		}
		return part;
	});
};
